const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            ?.setAttribute("href", event.currentTarget.dataset.variantLink);

          const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
          if (addButton) {
            addButton.setAttribute("aria-disabled", false);
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] > span')
              ?.classList.remove("hidden");
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
              ?.classList.add("hidden");
            const variantInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
            if (variantInput) variantInput.value = event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null && item.options.includes(currentColor)
              )[0];

              if (!variant) return;

              const newPrimaryImage = createImageElement(
                variant["featured_media"],
                primaryImage.className,
                primaryImage.sizes,
                product.title
              );

              if (newPrimaryImage.src === primaryImage.src) return;

              let secondaryBecamePrimary = false;
              if (secondaryImage) {
                const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                if (secondaryImagePathname === newPrimaryImagePathname) {
                  primaryImage.remove();
                  secondaryImage.classList.remove("media--second");
                  secondaryImage.classList.add("media--first");
                  secondaryBecamePrimary = true;
                }
              }

              if (!secondaryBecamePrimary) {
                primaryImage.animate(
                  { opacity: [1, 0] },
                  { duration: 200, easing: "ease-in", fill: "forwards" }
                );

                setTimeout(() => {
                  primaryImage.replaceWith(newPrimaryImage);
                  newPrimaryImage.animate(
                    { opacity: [0, 1] },
                    { duration: 200, easing: "ease-in" }
                  );
                  secondaryImage?.remove();
                }, 200);
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();
  document.addEventListener("shopify:section:load", checkSwatches);
}

colorSwatches();

/* Live In Peace product gallery overrides. Product-page gallery only. */
(function () {
  const style = document.createElement("style");
  style.id = "lip-product-gallery-layout";
  style.textContent = `
    /* Mobile: one near-full-width image per swipe, no thumbnail previews. */
    @media screen and (max-width: 749px) {
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__main,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-wrapper {
        width: 100% !important;
        max-width: 100% !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-wrapper {
        box-sizing: border-box;
        padding: 0 1px;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list-wrapper {
        display: block !important;
        position: relative;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        overflow: hidden;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-sublist-outer {
        display: none !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        overflow: hidden !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list > .swiper-wrapper {
        align-items: stretch;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-item {
        flex: 0 0 100% !important;
        width: 100% !important;
        min-width: 100% !important;
        height: auto !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .product__media {
        width: 100%;
        padding-top: 130% !important;
        border-radius: 0 !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .product__media img,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .deferred-media__poster img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
        object-position: center;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__slider-nav {
        display: none !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__pagination-wrapper {
        display: flex !important;
        position: absolute !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 1.4rem !important;
        z-index: 5;
        justify-content: center !important;
        align-items: center;
        width: 100%;
        padding: 0 !important;
        pointer-events: none;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__pagination {
        display: inline-flex !important;
        justify-content: center;
        align-items: center;
        gap: 0.65rem;
        width: auto !important;
        pointer-events: auto;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__pagination .swiper-pagination-bullet {
        flex: 0 0 0.5rem !important;
        width: 0.5rem !important;
        min-width: 0.5rem !important;
        height: 0.5rem !important;
        min-height: 0.5rem !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box;
        border: 0.1rem solid #02288c !important;
        border-radius: 50% !important;
        background: transparent !important;
        opacity: 1 !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__pagination .swiper-pagination-bullet::after {
        display: none !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__pagination .swiper-pagination-bullet-active {
        background: #02288c !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__info-container {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 2.4rem 1px 0 !important;
        box-sizing: border-box;
        align-items: stretch !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__info-container .product__info-main,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__info-container .product__info-main_content {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: auto !important;
        margin-right: auto !important;
        box-sizing: border-box;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__title__wrapper {
        justify-content: center;
        text-align: center;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .price-wrapper {
        justify-content: center;
      }
    }

    /* Desktop: gallery uses 60%, product information uses 40%, with a thin gutter. */
    @media screen and (min-width: 1200px) {
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside {
        display: grid !important;
        grid-template-columns: minmax(0, 60%) minmax(0, 40%) !important;
        gap: 0.6rem !important;
        width: 100% !important;
        max-width: none !important;
        padding: 0 0.6rem !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__main {
        order: 1;
        width: 100% !important;
        min-width: 0;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-wrapper,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list-wrapper,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list {
        width: 100% !important;
        max-width: none !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-sublist-outer {
        display: none !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .product__media {
        height: calc(100vh - var(--announcement-height, 0px) - var(--header-height, 0px) - 0.6rem) !important;
        min-height: 68rem;
        padding-top: 0 !important;
        border-radius: 0 !important;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .product__media img,
      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__media-list .deferred-media__poster img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
        object-position: center;
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__info-container {
        order: 2;
        align-self: start;
        box-sizing: border-box;
        width: 100% !important;
        min-width: 0;
        margin: 0 !important;
        padding: 6.4rem clamp(3.2rem, 4vw, 6.4rem) !important;
        position: sticky;
        top: var(--header-height, 0px);
      }

      .template-product [id^="MainProduct-"] .product__outer--thumbs-aside .product__info-container .product__info-main {
        width: 100% !important;
        max-width: 56rem !important;
        margin: 0 auto !important;
      }
    }
  `;

  const existingStyle = document.getElementById(style.id);
  if (existingStyle) existingStyle.remove();
  document.head.appendChild(style);
})();
